import * as React from "react";

import { renderAppPaddleButton } from "./renderAppPaddleButton";
import { useAppPaddleButton } from "./useAppPaddleButton";
import { useAppPaddleButtonStyles } from "./useAppPaddleButtonStyles.styles";
import type { AppPaddleButtonProps } from "./AppPaddleButton.types";

export const AppPaddleButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppPaddleButtonProps>((props, ref) => {
    const state = useAppPaddleButton(props, ref);

    useAppPaddleButtonStyles(state);

    return renderAppPaddleButton(state, props);
  })
);

AppPaddleButton.displayName = "next/AppPaddleButton";
